import { CURRENCY } from 'app/constants/currency.constant';
import { RootState } from 'app/store';
import { createSelector } from 'reselect';
import franchisesAdapter from './franchises.adapter';

export const { selectAll: selectFranchises, selectById: selectFranchiseById } = franchisesAdapter.getSelectors(
  (state: RootState) => state.franchises || {},
);

export const franchisesSelector = (state: RootState) => state.franchises;

export const franchisesDialogSelector = createSelector(franchisesSelector, franchise => franchise.franchiseDialog);

export const selectUserFranchise = createSelector(franchisesSelector, franchise => franchise.entity);

export const selectFranchiseCurrency = createSelector(
  franchisesSelector,
  franchise => CURRENCY[franchise.entity.currencyCode],
);

export const selectFranchiseSmsPrice = createSelector(franchisesSelector, franchise => franchise.smsPrice);

export const selectClientQualificationModal = createSelector(
  franchisesSelector,
  franchise => franchise.qualificationModal,
);

export const selectAverageBasketModal = createSelector(franchisesSelector, franchise => franchise.averageBasketModal);

export const selectFranchiseApiKeyV1 = createSelector(franchisesSelector, franchise => franchise.apiKey.v1);
export const selectFranchiseApiKeyV2 = createSelector(franchisesSelector, franchise => franchise.apiKey.v2);
export const selectFranchiseDailyAppsKey = createSelector(franchisesSelector, franchise => franchise.apiKey.dailyapps);
